import lazyLoading from './lazyLoading'

export default {
  name: 'callCenter',
  meta: {
    expanded: false,
    title: 'Call Center',
    iconClass: 'vuestic-icon vuestic-icon-statistics'
  },
  children: [
    {
      name: 'callcenterReportSales',
      path: '/callcenter-report/sales',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Reporte Ventas'
      },
      children: [
        {
          path: '', // Ruta por defecto
          component: lazyLoading('callCenter/SalesList'),
          meta: {
            title: 'Reporte Ventas'
          }
        },
      ]
    },
    {
      name: 'callcenterReportClients',
      path: '/callcenter-report/clients',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Reporte Clientes'
      },
      children: [
        {
          path: '', // Ruta por defecto
          component: lazyLoading('callCenter/CallcenterClientList'), // Apunta al nuevo componente
          meta: {
            title: 'Reporte Clientes'
          }
        },
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/callCenter.js